__turbopack_context__.v({
  "highlight": "VYyiaa_highlight",
  "modalBody": "VYyiaa_modalBody",
  "modalClose": "VYyiaa_modalClose",
  "modalEmpty": "VYyiaa_modalEmpty",
  "modalFooter": "VYyiaa_modalFooter",
  "modalGrid": "VYyiaa_modalGrid",
  "modalHeader": "VYyiaa_modalHeader",
  "modalLoading": "VYyiaa_modalLoading",
  "modalSearchWrap": "VYyiaa_modalSearchWrap",
  "modalSentinel": "VYyiaa_modalSentinel",
  "modalTitle": "VYyiaa_modalTitle",
  "newsFooter": "VYyiaa_newsFooter",
  "newsHighlightRing": "VYyiaa_newsHighlightRing",
  "newsList": "VYyiaa_newsList",
  "newsModal": "VYyiaa_newsModal",
  "newsPage": "VYyiaa_newsPage",
  "newsPageBadge": "VYyiaa_newsPageBadge",
  "newsPageBadgeText": "VYyiaa_newsPageBadgeText",
  "newsPageClose": "VYyiaa_newsPageClose",
  "newsPageEmpty": "VYyiaa_newsPageEmpty",
  "newsPageHeader": "VYyiaa_newsPageHeader",
  "newsPageList": "VYyiaa_newsPageList",
  "newsPageSearch": "VYyiaa_newsPageSearch",
  "newsPageTitle": "VYyiaa_newsPageTitle",
  "newsPageTitleRow": "VYyiaa_newsPageTitleRow",
  "newsPanel": "VYyiaa_newsPanel",
  "rail": "VYyiaa_rail",
  "railSpacer": "VYyiaa_railSpacer",
  "viewAll": "VYyiaa_viewAll",
  "viewFeed": "VYyiaa_viewFeed",
  "viewFeedSolo": "VYyiaa_viewFeedSolo",
});
